<template>
  <el-popover
      placement="top"
      ref="popover"
      width="600"
      trigger="click"
      @show="onPopupShow"
  >
    <note-form :key="formKey" ref="form" v-bind="formData" @stored="onStored" @cancel="onCancel" :can-set-read-only-note="canSetReadOnlyNote"></note-form>
    <slot slot="reference"></slot>
  </el-popover>
</template>

<script>
import NoteForm from "../../components/note/form";

export default {
  components: {
    NoteForm,
  },

  props: {
    note: Object,
    storeUrl: String,
    canSetReadOnlyNote: Boolean,
  },

  data() {
    return {
      formKey: this.newFormKey(),
    };
  },

  computed: {
    /**
     * @return {object}
     */
    formData() {
      return {
        model: _.get(this.note, 'model', {}),
        storeUrl: _.get(this.note, 'model') ? this.note.updateUrl : this.storeUrl,
      }
    },
  },

  methods: {
    /**
     * @param message
     * @param model
     * @event stored
     */
    onStored({message, model}) {
      this.$refs.popover.doClose();
      this.$message.success(message);
      this.$emit('stored', {model});
    },

    /**
     * @return {undefined}
     */
    onCancel() {
      this.$refs.form.init;
      this.$refs.popover.doClose();
    },

    /**
     * @return {undefined}
     */
    onPopupShow() {
      this.formKey = this.newFormKey();
    },

    /**
     * @return {number}
     */
    newFormKey() {
      return moment().unix();
    }
  },
}
</script>
